import windowSize from './windowSize';

/*
animationStartOffset can be:
- distance in pixels from window bottom
- callback witch will return this distance
*/

const isInViewport = (element, animationStartOffset = null) => {
    let offset;
    switch (true) {
    case typeof animationStartOffset === 'number':
        offset = windowSize.height - animationStartOffset;
        break;
    case animationStartOffset instanceof Function:
        offset = windowSize.height - animationStartOffset();
        break;
    default:
        offset = windowSize.height * 0.7;
        break;
    }
    const blockRect = element.getBoundingClientRect();
    if (blockRect.top < 0 && blockRect.top < -blockRect.height) return false;
    return blockRect.top - offset < 0;
};

export default isInViewport;
